export default __webpack_public_path__ + "static/media/editIcon.df1a471d.svg";